var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultInfoAvatarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 380,
    fill: "#D7D7DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22603_215376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.514 249.757C247.545 251.672 247.514 253.588 247.436 255.488C247.327 257.762 247.093 260.176 245.707 261.967C243.807 264.412 240.397 264.972 237.313 265.253C228.405 266.063 219.45 266.016 210.511 265.985C189.315 265.891 168.119 265.813 146.923 265.72C141.877 265.704 136.831 265.673 131.816 265.175C129.574 264.957 127.191 264.552 125.571 262.994C122.285 259.849 123.516 252.934 123.438 248.822C123.344 243.013 124.294 237.002 125.602 231.349C128.219 220.026 133.249 209.187 140.771 200.279C152.062 186.885 169.209 178.164 186.714 178.538C204.92 178.943 222.222 189.159 232.984 203.861C242.608 217.021 247.249 233.404 247.514 249.741V249.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.973 166.063C203.674 166.11 219.746 150.178 219.761 130.586C219.777 110.979 203.767 95.0312 184.051 95C164.35 94.9689 148.278 110.916 148.262 130.508C148.262 150.131 164.21 166.016 183.973 166.079V166.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.311 241.565C304.265 241.736 304.218 241.892 304.171 242.063C303.424 244.758 302.24 247.499 299.873 248.931C297.864 250.131 295.403 250.177 293.052 250.177C280.998 250.193 268.928 250.208 256.874 250.224V249.757C256.874 224.917 246.938 202.708 231.317 187.913C247.576 177.775 269.956 178.429 285.545 189.611C301.461 201.011 309.264 222.627 304.311 241.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.808 174.676C273.07 174.738 285.701 162.263 285.716 147.094C285.748 131.848 273.304 119.389 257.995 119.342C242.733 119.295 230.102 131.739 230.025 146.908C229.947 161.998 242.561 174.613 257.808 174.691V174.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9795 241.565C68.0262 241.736 68.0729 241.892 68.1197 242.063C68.8672 244.758 70.0508 247.499 72.418 248.931C74.427 250.131 76.8877 250.177 79.2393 250.177C91.2934 250.193 103.363 250.208 115.417 250.224V249.757C115.417 224.917 125.353 202.708 140.974 187.913C124.715 177.775 102.335 178.429 86.7459 189.611C70.8295 201.011 63.027 222.627 67.9795 241.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.483 174.676C99.2205 174.738 86.5902 162.263 86.5746 147.094C86.5434 131.848 98.9869 119.389 114.296 119.342C129.558 119.295 142.189 131.739 142.266 146.908C142.344 161.998 129.729 174.613 114.483 174.691V174.676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22603_215376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.291,
    height: 171,
    fill: "white",
    transform: "translate(66.5 95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultInfoAvatarGroup);
export default __webpack_public_path__ + "static/media/default_info_avatar_group.e56408a2e1a19021ac28b6e2f52887d8.svg";
export { ForwardRef as ReactComponent };